<template>
  <div class="relative">
    <button
      type="button"
      @click="open = !open"
      class="h-7 inline-flex items-center gap-1 px-2.5 text-xs font-medium rounded-lg transition-colors"
      :class="selected.length
        ? 'bg-blue-600 text-white'
        : 'bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700'"
    >
      {{ label }}
      <span v-if="selected.length" class="tabular-nums">{{ selected.length }}</span>
      <svg class="w-3 h-3 flex-shrink-0" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24" aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7"/>
      </svg>
    </button>

    <div v-if="open" @click="open = false" class="fixed inset-0 z-20"></div>
    <div v-if="open" class="absolute left-0 top-full mt-1.5 z-30 min-w-[11rem] p-1.5 bg-white dark:bg-[#2A3037] border border-gray-100 dark:border-gray-700 rounded-xl shadow-lg">
      <button
        v-for="opt in options" :key="opt.value"
        type="button"
        @click="toggle(opt.value)"
        class="w-full flex items-center gap-2 px-2 py-1.5 rounded-lg text-xs font-medium text-left text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors"
      >
        <span
          class="w-3.5 h-3.5 rounded flex-shrink-0 border flex items-center justify-center"
          :class="selected.includes(opt.value) ? 'bg-blue-600 border-blue-600' : 'border-gray-300 dark:border-gray-600'"
        >
          <svg v-if="selected.includes(opt.value)" class="w-2.5 h-2.5 text-white" fill="none" stroke="currentColor" stroke-width="3.5" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7"/>
          </svg>
        </span>
        <span v-if="swatches && opt.hex" class="w-2.5 h-2.5 rounded-full flex-shrink-0" :style="{ backgroundColor: opt.hex }"></span>
        {{ opt.label }}
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const props = defineProps({
  label: { type: String, required: true },
  options: { type: Array, required: true },
  selected: { type: Array, required: true },
  swatches: { type: Boolean, default: false },
})
const emit = defineEmits(['update'])

const open = ref(false)

// Emits a fresh array rather than mutating the store's own, so the store stays
// the only thing that writes to its state.
function toggle(value) {
  const next = props.selected.includes(value)
    ? props.selected.filter(v => v !== value)
    : [...props.selected, value]
  emit('update', next)
}
</script>
